import api from '@pray/shared/utils/api';

// The DELETE warmup endpoint responds 204 No Content — there is no body to unwrap.
export async function deleteWarmupCampaign({
  artistId,
  warmupCampaignId,
}: {
  artistId: string;
  warmupCampaignId: string;
}): Promise<void> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!warmupCampaignId) throw new Error('Warmup campaign ID is required');

  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupCampaignId}`;
  await api.executeDeleteRequest<void>(url);
}
